import src from "IMAGE";
export default { src, width: 920, height: 150, blurWidth: 0, blurHeight: 0};
